import React from "react";
import styles from "./styles.module.scss";
import Image from "next/image";
import Link from "next/link";
import { homePageMenuList } from "@/components/HomePage/constants";
import EarlyAccessButton from "../EarlyAccessButton";

interface HeaderProps {
  onDownloadClick: () => void;
}

const Header = ({ onDownloadClick }: HeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <img src="https://fellou.s3.us-west-1.amazonaws.com/images/20250913-155249.png" alt="Fellou" />
      </div>
      <div className={styles.menu}>
        {homePageMenuList.map((item, index) => (
          <Link
            href={item.href}
            key={`menu-item-${index}`}
            target={
              item.href === "/" || item.href === "/use-cases/" || item.href === "/pricing/" ? undefined : "_blank"
            }
            data-id={item.href}
            className={styles.menuItem}>
            {item.title}
          </Link>
        ))}
      </div>
      <EarlyAccessButton style={{ fontSize: "16px" }} onClick={onDownloadClick} />
    </div>
  );
};

export default Header;
